import { Box, Divider, Stack } from "@mui/material";
import { Labeled, RaRecord, TextField, useRecordContext } from "react-admin";
import { GenericColorChip } from "shared/components/chips/GenericColorChip";
import { GroupeModeColorMapping } from "shared/enums/colorMappings/globalColorMappings";
import { FormattedGroupTypeEnum } from "shared/enums/globalEnums";
import PlanningMaskField from "../../shared/PlanningMaskField";

export default function GroupBasicInfos() {
  const record = useRecordContext<RaRecord>();
  const type = record?.type;
  const formattedType = type ? FormattedGroupTypeEnum[type as keyof typeof FormattedGroupTypeEnum] : "";
  return (
    <Box p={2}>
      <Stack direction={"row"} spacing={4}>
        <Labeled>
          <TextField source="name" />
        </Labeled>
        <Labeled label={`Code ${formattedType}`}>
          <TextField source="code" />
        </Labeled>
        <Labeled label={`Code Tranche TM ${formattedType}`}>
          <TextField source="code_tm" />
        </Labeled>
        <Labeled>
          <GenericColorChip source="mode" colorMapping={GroupeModeColorMapping} />
        </Labeled>
        <Labeled source={"current_planning_mask"}>
          <PlanningMaskField source="current_planning_mask" />
        </Labeled>
      </Stack>
      <Divider sx={{ p: 2 }} />
    </Box>
  );
}
